import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * @deprecated Since 2026-10-23. Use `infcTranslationNoCacheInterceptor` from
 * `@infodata-group/inf-commons-core`.
 */
@Injectable()
export class TranslationInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (request.url.includes('/assets/i18n/')) {
      const newRequest = request.clone({
        url: `${request.url}?${new Date().getTime()}`,
      });
      return next.handle(newRequest);
    }
    return next.handle(request);
  }
}
